import React, { Component } from '../../lib/react';
import { Layout, Button } from 'antd';
import { hashHistory } from "react-router";

import { getInstagramFeed } from '../../services/instagram';
import { loadUserInfo } from '../../services/firebase/user';
import { getChat, postChat } from "../../services/firebase/chats";
import Events from "../../services/events";

import PageHeader from "../../components/Modules/PageHeader";
import FilterPanel from "../../components/Modules/FilterPanel";
import AskForLogin from '../../components/Modules/AskForLogin';
import InstagramFeed from '../../components/Modules/InstagramFeed';
import ProfileContent from '../../components/Modules/ProfileContent';

import './profileInfo.less';

const { Content } = Layout;

export default class ProfileInfo extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: null,
      email: null,
      instagramPosts: [],
      visibleRegistration: false,
      visibleAuth: true,
      reverseRedirection: null,
      activeType: 'auth'
    };

    const profileId = this.props.params.profileId;

    if (profileId) {
      loadUserInfo(profileId).then(res => {
        this.setState({ user: res });
        this.loadInstagramPosts(res).then(result => {
          this.setState({instagramPosts: result})
        });
      })
    }
  };

  componentDidMount() {
    const searchQuery = this.props.location.search;
    const urlParams = new URLSearchParams(searchQuery);
    const reverseRedirection = urlParams.get('redirect')
      ? urlParams.get('redirect')
      : null;

    if (reverseRedirection) {
      this.setState({ reverseRedirection: reverseRedirection });
    }
  };

  async loadInstagramPosts(userData) {
    let result = userData && await getInstagramFeed(userData.instagram || 'undefined');

    return result || []
  };

  async handleOpenChat(chatId) {
    let chatFirst = await getChat(chatId);
    let usersId = chatId.split('-');
    let secondVariableChatId = `${usersId[1]}-${usersId[0]}`;
    let chatSecond = await getChat(secondVariableChatId);

    if (chatFirst) {
      hashHistory.push(`/Messages/${chatId}`);
    } else if (chatSecond) {
      hashHistory.push(`/Messages/${secondVariableChatId}`);
    } else {
      postChat(chatId).then(() => {
        hashHistory.push(`/Messages/${chatId}`);
      })
    }
  };

  urlify(text) {
    let urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function(url) {
      return '<a target="_blank" href="' + url + '">' + url + '</a>'
    })
  };

  createMarkup(text) {
    return {__html: text};
  };

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  };

  setStateHandler = (obj) => {
    this.setState(obj)
  };

  render(){
    const { user, visibleRegistration, visibleAuth, reverseRedirection, activeType } = this.state;
    const currentUser = this.props.user;
    const { params } = this.props;
    const chatId = currentUser && currentUser.uid && `${currentUser.uid}-${params.profileId}`;

    let page = (
      <Layout className="page-wrapper">
        <Content className="feed">
          <PageHeader
            className="header"
            backTo={reverseRedirection ? reverseRedirection : "Past_Events/Surgeries"}
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  reverseRedirection={reverseRedirection ? reverseRedirection : null}
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="User search"
            mobileTypeSearch="user"
            reverseRedirection={reverseRedirection ? reverseRedirection : null}
          />
          <div className="page-content-inner">
            {
              user && <ProfileContent
                user={user}
                currentUser={currentUser}
                chatId={chatId}
                params={params}
                handleOpenChat={this.handleOpenChat}
              />
            }
            {
              this.state.instagramPosts && this.state.instagramPosts.length > 0 && (
                <InstagramFeed posts={ this.state.instagramPosts} />
              )
            }
          </div>
        </Content>
      </Layout>
    );
    if (!this.props.user || !this.props.user.uid) {
      page = (
        <React.Fragment>
          <PageHeader
            className="header"
            backTo="Past_Events/Surgeries"
            extra={
              <div className="search-form">
                <FilterPanel filter={this.filterBy} />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="User search"
            mobileTypeSearch="user"
          />
          <div className="container">
            <AskForLogin
              page="ProfileInfo"
              visibleRegistration={visibleRegistration}
              visibleAuth={visibleAuth}
              setStateHandler={this.setStateHandler}
              activeType={activeType}
            />
          </div>
        </React.Fragment>
      )
    }

    return page;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProfileInfo/index.js